import React, { useState, useEffect } from "react";
import { object, string } from "yup";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { Form, Button, Row, Space } from "@masterteam/mt-design-react";

import AdminFormModal from "../../../AdminFormModal";
import api from "../../../../providers/api";
import { addToast } from "../../../../helpers";

import "./style.scss";

const { Field } = Form;

const validationSchema = object().shape({
  StakeholderName: string().required(" "),
  Classification: object().required(" "),
});

const StakeholderForm = ({
  data,
  lists,
  closeModal,
  stakeholders,
  setStakeholders,
  initiativeData = null,
  getData = () => {},
}) => {
  const intl = useIntl();
  const isAr = intl.locale === "ar";
  const StakeholderClassification = useSelector(
    ({ theme }) => theme.StakeholderClassification.item.Items
  );

  const [loading, setLoading] = useState(true);
  const [stakeholderModel, setStakeholderModel] = useState(null);
  const [initialValues, setInitialValues] = useState({
    StakeholderName: "",
    Classification: StakeholderClassification[0],
  });

  useEffect(() => {
    if (data) {
      const user = lists.users.find((e) => e.UserName === data.StakeholderName);
      setStakeholderModel(user);
      setInitialValues({
        ...data,
        Classification: StakeholderClassification.find(
          (e) => e.Value === data.Classification
        ),
      });
    }
    setLoading(false);
  }, []);

  const onSubmit = async (values, { setSubmitting }) => {
    let body = {
      ...values,
      Classification: values.Classification.Value,
      ID: data ? data.ID : stakeholders?.length + 1,
    };

    if (initiativeData) {
      body = { ...body, InitiativeID: initiativeData.ID, ID: data?.ID };
      try {
        const service = data ? "updateStakeholder" : "createStakeholder";
        const res = await api.initiatives[service](body);
        const { StatusCode } = res;
        if (StatusCode === "Success") {
          addToast.success(data ? "toast.successUpdate" : "toast.successSave");
          getData();
          closeModal();
        }
      } catch (error) {
        addToast.error(error?.message, {
          toastId: "get-users-error",
        });
      } finally {
        setSubmitting(false);
      }
    } else if (data) {
      const newData = [...stakeholders];
      const index = stakeholders.findIndex((e) => e.ID === data.ID);
      newData[index] = body;
      setStakeholders([...newData]);
    } else setStakeholders([...stakeholders, body]);
    setSubmitting(false);
    closeModal();
  };

  return (
    <AdminFormModal
      title={intl.formatMessage({
        id: data
          ? "initiative.update-stakeholder"
          : "initiative.add-stakeholder",
      })}
      isLoading={loading}
      onClose={closeModal}
    >
      <Form
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ values, errors, isSubmitting, isValid, setFieldValue }) => (
          <>
            <Space
              direction="vertical"
              size="medium"
              className="performance-indicator-form-body"
            >
              <Space direction="vertical" className="container" size="large">
                <Row size="small">
                  <div style={{ flex: 1 }}>
                    <Field
                      type="select"
                      label={intl.formatMessage({
                        id: "initiative.classification",
                      })}
                      name="Classification"
                      inputProps={{
                        options: StakeholderClassification,
                        getOptionLabel: (el) => (isAr ? el.Arabic : el.English),
                        getOptionValue: (el) => el?.Value,
                        placeholder: intl.formatMessage({
                          id: "initiative.classification",
                        }),
                        onChange: (value) => {
                          setFieldValue("Classification", value);
                          setFieldValue("StakeholderName", null);
                        },
                      }}
                      hideErrorMessage
                      required
                    />
                  </div>
                  <div style={{ flex: 2 }}>
                    {values?.Classification?.Value === "1" ? (
                      <Field
                        name="StakeholderName"
                        label={intl.formatMessage({
                          id: "initiative.stakeholder-name",
                        })}
                        inputProps={{
                          placeholder: intl.formatMessage({
                            id: "initiative.stakeholder-name",
                          }),
                        }}
                        hideErrorMessage
                        required
                      />
                    ) : (
                      <Field
                        type="select"
                        label={intl.formatMessage({
                          id: "initiative.stakeholder-name",
                        })}
                        inputProps={{
                          options: lists.users,
                          value: stakeholderModel,
                          getOptionLabel: (el) => el.DisplayName,
                          getOptionValue: (el) => el?.UserName,
                          maxMenuHeight: "70px",
                          placeholder: intl.formatMessage({
                            id: "initiative.stakeholder-name",
                          }),
                          onChange: (value) => {
                            setStakeholderModel(value);
                            setFieldValue("StakeholderName", value?.UserName);
                          },
                        }}
                        hideErrorMessage
                        required
                      />
                    )}
                  </div>
                </Row>
              </Space>
              <Row justify="end" className="form-footer">
                <Button
                  loading={isSubmitting}
                  disabled={!isValid}
                  variant="primary"
                  type="submit"
                  fixed
                >
                  {intl.formatMessage({
                    id: data ? "common.update" : "common.add",
                  })}
                </Button>
              </Row>
            </Space>
          </>
        )}
      </Form>
    </AdminFormModal>
  );
};

export default StakeholderForm;
